var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWww(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 18c4.963 0 9-4.038 9-9 0-4.963-4.037-9-9-9C4.039 0 .002 4.037.002 9c0 4.962 4.037 9 9 9zm0-2.096a6.809 6.809 0 01-3.937-1.239c.473-.783 1.908-2.747 4.984-3.92a30.734 30.734 0 011.33 4.737A6.824 6.824 0 019 15.904zm4.385-1.579a33.223 33.223 0 00-1.135-4.108c.309-.03.624-.046.944-.046 1.117 0 2.049.187 2.541.31a6.932 6.932 0 01-2.35 3.844zm1.265-9.258a6.92 6.92 0 011.218 3.356 18.725 18.725 0 00-2.957-.245c-.49 0-.965.022-1.415.067l-.036-.085c-.094-.22-.195-.446-.301-.674 1.837-.824 2.95-1.834 3.491-2.419zM9 2.118c1.548 0 3.044.521 4.256 1.475-.418.467-1.37 1.356-3.046 2.05a40.032 40.032 0 00-2.183-3.456c.321-.046.647-.069.974-.069zm-3.247.815c.405.57 1.297 1.862 2.197 3.41-2.422.584-4.55.71-5.566.735a6.948 6.948 0 013.37-4.145zm3.232 5.323c.078.159.153.315.225.468-3.059 1.052-4.958 3.396-5.692 4.46a6.87 6.87 0 01-1.407-3.967c1.065-.011 3.905-.127 6.874-.96z",
    fill: "#EA4C89"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWww);
export default __webpack_public_path__ + "static/media/www.e81841edcf0ff916f381860d79f39a1f.svg";
export { ForwardRef as ReactComponent };